import { MoreDotsIcon } from '@tableau/icons/MoreDotsIcon';
import { ButtonType, ButtonWidget, FlyoutListMenuWidget, HorizontalOriginOption, MenuItemInfo, VerticalOriginOption } from '@tableau/widgets';
import { BodyCell } from '@tableau/widgets-datagrid';
import * as React from 'react';

import { Messages } from '~src/codegen/Localize';

import { GeocodingRecordDGConstants } from '../recordDialog/GeocodingRecordDataGrid';

export enum ActionMenuOptions {
  Edit = 'edit-geo-config',
  Delete = 'delete-geo-config',
}

export interface GeocodingRecordActionCellFormatterState {
  isActionMenuOpen: boolean;
  menuInfos: MenuItemInfo[];
}

export class GeocodingRecordActionCellFormatter extends React.Component<BodyCell.Props, GeocodingRecordActionCellFormatterState> {
  private menuID = 'geo-config-dg-action-menu';
  private actionMenuAnchor: HTMLElement = null;

  public constructor(props: BodyCell.Props) {
    super(props);

    this.actionMenuAnchor = null;

    this.state = {
      isActionMenuOpen: false,
      menuInfos: [
        { value: ActionMenuOptions.Edit, displayValue: Messages.geocodingRecordActionEdit() },
        { value: ActionMenuOptions.Delete, displayValue: Messages.geocodingRecordActionDelete() }
      ],
    };
  }

  public toggleActionMenu = (): void => {
    this.state.isActionMenuOpen ? this.closeActionMenu() : this.openActionMenu();
  };

  public openActionMenu = (): void => {
    this.setState({ isActionMenuOpen: true });
  };

  public closeActionMenu = (): void => {
    this.setState({ isActionMenuOpen: false });
  };

  public onSelectMenuItem = (value: string): void => {
    const rowData = this.props.row.data;

    switch(value) {
      case ActionMenuOptions.Edit: {
        rowData[GeocodingRecordDGConstants.HandleEdit](rowData[GeocodingRecordDGConstants.GeocodingConfigObj]);
        break;
      }
      case ActionMenuOptions.Delete:
        rowData[GeocodingRecordDGConstants.HandleDelete](rowData[GeocodingRecordDGConstants.ConfigId]);
        break;
      default:
        break;
    }
    this.closeActionMenu();
  };

  public render(): JSX.Element {
    const { isActionMenuOpen, menuInfos } = this.state;
    return (
      <>
        <div ref={(elem) => this.actionMenuAnchor = elem }>
          <ButtonWidget
            buttonType={ButtonType.LowEmphasis}
            onClick={this.toggleActionMenu}
            testId={this.menuID}
          >
            <MoreDotsIcon size={12} />
          </ButtonWidget>
        </div>
        {isActionMenuOpen && (
          <FlyoutListMenuWidget
            allowAutoPosition={true}
            anchorEl={this.actionMenuAnchor}
            anchorOrigin={{
              horizontal: HorizontalOriginOption.right,
              vertical: VerticalOriginOption.top,
            }}
            menuItemInfos={menuInfos}
            onSelect={this.onSelectMenuItem}
            requestCloseAll={this.closeActionMenu}
            testId={this.menuID}
            toggleEl={this.actionMenuAnchor}
          />
        )}
      </>
    );
  }
}
